import type { GetAccountSuccess, RegisterAccountSuccess } from '@/app_lib/piano/entities';
import type { Tinypass } from '@/app_lib/types/accounts/piano/tinypass';
import { geoIp } from '@/app_lib/utils/paymentApi/geoip';

export async function getExistingPianoUid(email: string): Promise<string | null> {
  const checkAccountResponse = await fetch('/api/checkPianoAccountExists', {
    body: JSON.stringify({ email }),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  });

  if (!checkAccountResponse.ok) {
    if (checkAccountResponse.status === 404) {
      // Successful api call, but no user found
      // Saving space if we wanted to do something different here in the future
      return null;
    }
    // Where we would do something if the Piano API call fails
    // Saving space if we wanted to do something different here in the future
    return null;
  }

  const userData: GetAccountSuccess = await checkAccountResponse.json();

  return userData.getUserResponse.uid;
}

export async function registerPasswordlessPianoUser(params: {
  consent: boolean;
  email: string;
}): Promise<string | null> {
  const registerAccountResponse = await fetch('/api/registerPasswordlessPianoAccount', {
    body: JSON.stringify(params),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  });

  if (!registerAccountResponse.ok) {
    if (registerAccountResponse.status === 409) {
      // This is where we would handle the case where the user already exists
      return null;
    }
    // This would be where we handle a failed registration due to API failure
    // This shouldn't block the user from subscribing, but we may want to log this somewhere so that we know the SF account won't have an associated Piano account
    return null;
  }

  const response: RegisterAccountSuccess = await registerAccountResponse.json();

  const pianoUid = response.pianoUid;

  if (pianoUid) {
    await geoIp(pianoUid, 'newsletter_template', response.accessToken);
  }

  return pianoUid;
}

export const getLts = (tp: Tinypass, experienceId: string, eventType: string): string => {
  const experienceResult = tp.experience._getLastExecutionResult();
  const userSegments = experienceResult.result?.events.find(
    (event) => event.eventType === eventType && event.eventExecutionContext.experienceId === experienceId,
  )?.eventExecutionContext.userSegments;
  const lts = userSegments?.COMPOSER1X
    ? userSegments?.COMPOSER1X.segments.find((score) => score.startsWith('LTs'))
    : 'no_score';

  return lts || 'no_score';
};
